export function getEnvValue(key) {
    return process.env[key];
  }
  